import { render, staticRenderFns } from "./MainRoomWidget.vue?vue&type=template&id=01cd7a14"
import script from "./MainRoomWidget.vue?vue&type=script&lang=js"
export * from "./MainRoomWidget.vue?vue&type=script&lang=js"
import style0 from "./MainRoomWidget.vue?vue&type=style&index=0&id=01cd7a14&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports